import { MainInner, MainSection } from "@/styles/global";
import { Body, H2 } from "@/styles/typography";
import styled from "styled-components";

const Section = styled(MainSection)``;

const Inner = styled(MainInner)``;

const Title = styled(H2)`
  margin-bottom: 24px;
`;

const Description = styled(Body)`
  margin-bottom: 24px;
`;

const S = {
  Section,
  Inner,
  Title,
  Description,
};

export default S;
